import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';

import css from 'css';
import Container from 'partials/Container';
import Html from 'partials/Html';

class RichText extends Component {
    render() {
        const { data } = this.props;
        //console.log('Rich text:',data);
        return (
            <ModuleWrapper>
                <Container>
                    <Html className="content-wrapper">{data.content}</Html>
                </Container>
            </ModuleWrapper>
        );
    }
}

export default withRouter(RichText);

const ModuleWrapper = styled.div`
    margin-bottom:100px;
    @media (max-width: 768px) {
        margin-bottom:50px;
    }
    strong {
        font-family: ${css.fonts.bg_bold};
    }
    em {
        font-style: italic;
    }
    @media (max-width: 1080px) {
        p, ul li, ol li {
            font-size:16px;
        }
    }
`



// WEBPACK FOOTER //
// ./src/partials/modules/RichText.js